module.exports = function(app) {
	'use strict';
	app.factory('addFlowCommander', ['$state', 'employee', 'coverageBuddy','sessionData','services', function($state, employee, coverageBuddy,sessionData, services) {

        var hasSEP = false;
		var allLinks = {
			subscriberAndDependents: {
				heading: 'Subscriber & Dependents',
				state: 'employee.add.subscriber',
				description: 'Add Employee Information',
				step: '1.',
				required: true,
				approved: false,
				priority: 1
			},
			otherInsurance: {
				heading: 'Other Insurance',
				state: 'employee.add.otherInsurance',
				description: 'Other insurance and Management',
				step: '',
				required: false,
				approved: false,
				priority: 2
			},
			medicare: {
				heading: 'Medicare',
				state: 'employee.add.medicare',
				description: 'Medicare information',
				step: '',
				required: false,
				approved: false,
				priority: 3
			},
			mnloa: {
				heading: 'MNLOA',
				state: 'employee.add.mnloa',
				description: 'MNLOA',
				step: '',
				required: false,
				approved: false,
				priority: 4
			},
			planCoverage: {
				heading: 'Plan Coverage',
				state: 'employee.add.coverage',
				description: 'Plan Coverage Management',
				step: '2.',
				required: true,
				approved: false,
				priority: 5
			},
			majorMedical: {
				heading: 'Major Medical',
				state: 'employee.add.majorMedical',
				description: 'Major Medical Products',
				step: '',
				required: false,
				approved: false,
				priority: 6
			},
			reviewAndSubmit: {
				heading: 'Review & Submit',
				state: 'employee.add.reviewSubmit',
				description: 'Confirm and Submit information.',
				step: '3.',
				required: true,
				approved: false,
				priority: 7
			}
		};

		var sidebar = {
			formConfig: { enforceSteps: true },
			links: [
				allLinks.subscriberAndDependents,
				allLinks.planCoverage,
				allLinks.reviewAndSubmit
			],

			reset: function() {
				this.links = [
					allLinks.subscriberAndDependents,
					allLinks.planCoverage,
					allLinks.reviewAndSubmit
				];
				this.links.forEach(function(link) {
					link.required = true;
					link.approved = false;
				});
			},

			refill: function() {
				while (this.links.length) { this.links.pop(); }
				Object.keys(allLinks).forEach(function(name) {
					if (allLinks[name].required) { this.links.push(allLinks[name]); }
				}.bind(this));
			},

			sort: function() {
				this.links.sort(function(x, y) {
					return x.priority > y.priority;
				});
			},

			setStepNumbers: function() {
				this.links.forEach(function(link, i) {
					link.step = (i + 1) + '.';
				});
			},

			getCurrentStep: function() {
				for (var i = 0; i < this.links.length; ++i) {
					if (this.links[i].state === $state.current.name) {
						return this.links[i];
					}
				}
			},

			getPreviousStep: function() {
				var currentStepIndex = this.links.indexOf( this.getCurrentStep() );
				if (currentStepIndex > 0) {
					return this.links[ --currentStepIndex ];
				}
				return { state: 'home' };
			},

			getNextStep: function() {
				return this.getNextSteps()[0];
			},

			getNextSteps: function() {
				var currentStepIndex = this.links.indexOf( this.getCurrentStep() );
				if (currentStepIndex < (this.links.length - 1)) {
					return this.links.slice(++currentStepIndex);
				}
				return [{ state: 'home' }];
			},

			isOtherInsuranceRequired: function(e, isCOB) {
				e = e || employee;
				// if it is COB we need to make sure appropiriate attributte are there to show other insurance section
				var isOtherInsuranceRequiredToDisplay;
				isOtherInsuranceRequiredToDisplay = ([e.data.subscriber].concat(e.data.dependents)).some(
					function(p) {
						return p.otherInsuranceIndicator == 'yes';
					}
				);
				if(!isOtherInsuranceRequiredToDisplay && isCOB && 'isCOBDataProcessed' in e.data){
					if(sessionData.employerInfo.brandName == '6010' || sessionData.employerInfo.brandName == '6011' || sessionData.employerInfo.brandName == '6012') {
						isOtherInsuranceRequiredToDisplay = e.data.isCOBDataProcessed;
					}
				}
				return isOtherInsuranceRequiredToDisplay;
			},
			isMedicareRequired: function(e) {
				e = e || employee;
				return ([e.data.subscriber].concat(e.data.dependents)).some(
					function(p) { return p.medicareEligibleIndicator === 'yes'; }
				);
			},

			isMNLOARequired: function(e) {
				e = e || employee;
				return e.data.dependents.some(
					function(p) {
						return p.dependentStatus && p.dependentStatus === 'M';
					}
				);
			},

			isMajorMedicalRequired: function(e, override) {
				if (override && override.hasOwnProperty('majorMedical')) {
					return override.majorMedical;
				}
				e = e || employee;
				return (e.data.subscriber.memberCoverages || []).some(coverageBuddy.groupIsMajorMedical);
			},

			requireConditionalSteps: function(e, override) {
				allLinks.medicare.required = this.isMedicareRequired();
				allLinks.otherInsurance.required = this.isOtherInsuranceRequired();
				allLinks.mnloa.required = this.isMNLOARequired();
				allLinks.majorMedical.required = this.isMajorMedicalRequired(e, override);
			},

			update: function(e, override) {
				this.requireConditionalSteps(e, override);
				this.refill();
				this.sort();
				this.setStepNumbers();
			}
		};


        if(sessionData.appConfig && sessionData.appConfig.SEP) {
            hasSEP = sessionData.appConfig.SEP.booleanValue;
			// sessionData.appConfig.SEP.booleanValue;
        }

        var outSideOpen = false;
        if(hasSEP) {
            services.eprsvc.lifeEventRules().checkOpenEnrollment().then(
                function (response) {
                    if (response) {
                        outSideOpen = response;
                    }
                });
        }

		var enrollmentInProcess = { // methods only applicable to and accurate for in-process enrollments -- I've embedded these in an object so that the manner
			completed: {      		// in which they're called makes it obvious that they apply only to return visitors and are not for validating new enrollments
                subscriberAndDependents: function(employee) {
                    if(outSideOpen){
                        if(!employee.data.subscriber.eventCode && !employee.data.subscriber.eventDate){
                            return false;
                        }
                        else{
                            return Boolean(employee.data.subscriber.ssn);
                        }
                    }
                    else {
                        if(employee.data.subscriber.eventCode && employee.data.subscriber.eventDate){
                            delete employee.data.subscriber.eventCode;
                            delete employee.data.subscriber.eventDate;
                            var dependents = employee.data.dependents;
                            if(dependents.length > 0){
                                dependents.forEach(function(dep){
                                    if(dep.eventCode && dep.eventDate){
                                        delete dep.eventCode;
                                        delete dep.eventDate;
                                    }

                                });
                            }
                        }
                        return Boolean(employee.data.subscriber.ssn);
                    }
                },

				otherInsurance: function(employee) { // I have no idea if this method is remotely correct - need to find out what the otherInsurance data looks like
					var subscriber = employee.data.subscriber;
					var dependents = employee.data.dependents;
					return Boolean(
						subscriber.otherInsurance && subscriber.otherInsurance instanceof Object && Object.keys(subscriber.otherInsurance).length ||
						dependents.some(function(d) { return d.otherInsurance && d.otherInsurance instanceof Object && Object.keys(d.otherInsurance).length; })
					);
				},

				medicare: function(employee) {
					var subscriber = employee.data.subscriber;
					var dependents = employee.data.dependents;

					return Boolean(
						subscriber.medicareEligible &&
						subscriber.medicareEligible instanceof Object &&
						Object.keys(subscriber.medicareEligible).filter(function(k) { return subscriber.medicareEligible[k]; }).length ||
						dependents.some(
							function(d) {
								return (
									d.medicareEligible &&
									d.medicareEligible instanceof Object &&
									Object.keys(d.medicareEligible).filter(
										function(k) { return d.medicareEligible[k]; }
									).length
								);
							}
						)
					);
				},

				mnloa: function(employee) {
					return Boolean(
						employee.data.dependents.some(function(d) { return d.mnloa && d.mnloa instanceof Object && Object.keys(d.mnloa).length; })
					);
				},

				planCoverage: function(employee) {
					var subscriber = employee.data.subscriber;
					return Boolean(
						Array.isArray(subscriber.memberCoverages) &&
						subscriber.memberCoverages.length &&
						subscriber.memberCoverages[0] instanceof Object &&
						Array.isArray(subscriber.memberCoverages[0].memberLobs) &&
						subscriber.memberCoverages[0].memberLobs.length
					);
				},

				majorMedical: function() {
					// at the moment, we are optimistically giving the enrollees all sub-products, so the
					// criterium for completion is the same as that which requires the step in the sidebar
					return sidebar.isMajorMedicalRequired();
				}
			},

			getFirstIncompleteStep: function(employee) {
				allLinks.subscriberAndDependents.approved = enrollmentInProcess.completed.subscriberAndDependents(employee);
				allLinks.otherInsurance.approved = enrollmentInProcess.completed.otherInsurance(employee);
				allLinks.medicare.approved = enrollmentInProcess.completed.medicare(employee);
				allLinks.mnloa.approved = enrollmentInProcess.completed.mnloa(employee);
				allLinks.planCoverage.approved = enrollmentInProcess.completed.planCoverage(employee);
				allLinks.majorMedical.approved = enrollmentInProcess.completed.majorMedical();

				for (var i = 0; i < sidebar.links.length; ++i) {
					if (sidebar.links[i].required && !sidebar.links[i].approved) {
						return sidebar.links[i];
					}
				}
			},

			resume: function(subscriberSSN) {
				employee.loadEnrollment(subscriberSSN).then(
					function(employee) {
						sidebar.update();
						$state.go(enrollmentInProcess.getFirstIncompleteStep(employee).state, { subscriberSSN: subscriberSSN });
					}
				);
			}
		};


		return {

			sidebar: sidebar,
			enrollmentInProcess: enrollmentInProcess,

			isInAddFlow: function() {
				return $state.current.name.indexOf('employee.add') >= 0;
			},

			approveCurrentStep: function() {
				sidebar.getCurrentStep().approved = true;
				sidebar.getNextSteps().forEach(function(step) {
					step.approved = false;
				});
			},

			denyCurrentStep: function() {
				if (sidebar.getCurrentStep()) {
					sidebar.getCurrentStep().approved = false;
				}
				sidebar.getNextSteps().forEach(function(step) {
					step.approved = false;
				});
			},

			advance: function(subscriberSSN, destination) {
				var params = { subscriberSSN: subscriberSSN };

				if (destination) { return $state.go(destination, params); }
				if (sidebar.getCurrentStep().approved) { $state.go(sidebar.getNextStep().state, params); }
			},

			retreat: function(subscriberSSN) {
				$state.go(sidebar.getPreviousStep().state, { subscriberSSN: subscriberSSN });
			},

			isMNLOARequired: sidebar.isMNLOARequired,
			isOtherInsuranceRequired: sidebar.isOtherInsuranceRequired,
			isMedicareRequired: sidebar.isMedicareRequired,
			isMajorMedicalRequired: sidebar.isMajorMedicalRequired,

			setOtherInsurance: function(participant) {
				if (participant.otherInsuranceIndicator === "yes") {
					employee.addOtherInsurance(participant);
					allLinks.otherInsurance.approved = false;
				}
				else {
					delete participant.otherInsurance;
				}
				sidebar.update();
			},

			setMedicare: function(participant) {
				if (participant.medicareEligibleIndicator === "yes") {
					employee.addMedicare(participant);
					allLinks.medicare.approved = false;
				}
				else {
					delete participant.medicare;
				}
				sidebar.update();
			},

			setMNLOA: function(participant, value) {

				if (value === 'M' ) {
					employee.addMNLOA(participant);
					allLinks.mnloa.approved = false;
				}
				else {
                    delete participant.mnloa;
				}
				sidebar.update();
			},

			addDependent: function(employeeObj) {
				employee.addDependent(employeeObj);
				allLinks.subscriberAndDependents.approved = false;
				allLinks.planCoverage.approved = false;
			}
		};
	}]);
};
